import * as React from "react";

export interface Theme {
  colors: {
    primary: string;
    background: string;
    surface: string;
    text: string;
    muted: string;
    danger: string;
    success: string;
  };
  spacing: (n: number) => number;
  radius: number;
}

export const defaultTheme: Theme = {
  colors: {
    primary: "#247AC2",
    background: "#F7FAFD",
    surface: "#ffffff",
    text: "#172033",
    muted: "#64748B",
    danger: "#dc2626",
    success: "#16a34a",
  },
  spacing: (n: number) => n * 8,
  radius: 20,
};

/** Shared layout tokens used by the CORE shell on web and native. */
export const coreTokens = {
  colors: { ...defaultTheme.colors, border: "#E8EEF5", selected: "#E7F2FE" },
  radius: { control: 12, card: 20, shell: 30 },
  fontSize: { caption: 12, body: 14, title: 30 },
  spacing: defaultTheme.spacing,
} as const;

export interface ThemeProviderProps {
  children: React.ReactNode;
  theme?: Theme;
}

const ThemeContext = React.createContext<Theme>(defaultTheme);

export function ThemeProvider({ children, theme = defaultTheme }: ThemeProviderProps) {
  return <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>;
}

export function useTheme(): Theme {
  return React.useContext(ThemeContext);
}
